// Employee images – add new imports when you add a photo for an employee
import TimHeymannImg from './images/TimHeymann.png';
import SvenRosenthalImg from './images/SvenRosenthal.png';
import DeljanGallkowskiImg from './images/DeljanGallkowski.png';
import TheoLuensdorfImg from './images/TheoLuensdorf.png';
import SanaSaidykhanImg from './images/SanaSaidykhan.png';
import AlexanderKatonaImg from './images/AlexanderKatona.png';
import MarcJohnImg from './images/MarcJohn.png';
import GoranDjuricImg from './images/GoranDjuric.png';
import TimBoehmeImg from './images/TimBoehme.png';
import PierPaoloMuntoniImg from './images/PierPaoloMuntoni.png';
import AlexandraKellerImg from './images/AlexandraKeller.png';
import LeifHaackImg from './images/LeifHaack.png';
import StefanRampeImg from './images/StefanRampe.png';
import AdnanAoudouImg from './images/AdnanAoudou.png';
import KiraMuehlbergImg from './images/KiraMuehlberg.png';
import LindaAragonImg from './images/LindaAragon.png';
import AdrianTieberImg from './images/AdrianTieber.png';

/**
 * Employee config for upload forms.
 * Key = URL slug (e.g. tim-heymann → /tim-heymann).
 * Add new employees here; add their image to src/images and import it above.
 */
export const employees = {
  'alexandra-keller': {
    name: 'Alexandra Keller',
    position: 'Senior Consultant',
    image: AlexandraKellerImg,
    email: 'alexandra.keller@raising-standards.com',
    phone: '+49 1579 28 11 750'
  },
  'tim-heymann': {
    name: 'Tim Heymann',
    position: 'Geschäftsführer',
    image: TimHeymannImg,
    email: 'tim.heymann@raising-standards.com',
    phone: '+49 1579 24 84 330'
  },
  'sven-rosenthal': {
    name: 'Sven Rosenthal',
    position: 'Senior Manager',
    image: SvenRosenthalImg,
    email: 'sven.rosenthal@raising-standards.com',
    phone: '+49 157 924 745 45'
  },
  'deljan-gallkowski': {
    name: 'Deljan Gallkowski',
    position: 'Senior Consultant',
    image: DeljanGallkowskiImg,
    email: 'deljan.gallkowski@raising-standards.com',
    phone: '+49 157 924 745 48'
  },
  'theo-luensdorf': {
    name: 'Theo Lünsdorf',
    position: 'Junior Consultant',
    image: TheoLuensdorfImg,
    email: 'theo.luensdorf@raising-standards.com',
    phone: '+49 157 924 745 43'
  },
  'sana-saidykhan': {
    name: 'Sana Saidykhan',
    position: 'Manager',
    image: SanaSaidykhanImg,
    email: 'sana.saidykhan@raising-standards.com',
    phone: '+49 157 924 745 44'
  },
  'alexander-katona': {
    name: 'Alexander Katona',
    position: 'Junior Consultant',
    image: AlexanderKatonaImg,
    email: 'alexander.katona@raising-standards.com',
    phone: '+49 157 924 745 47'
  },
  'marc-john': {
    name: 'Marc John',
    position: 'Principal Consultant',
    image: MarcJohnImg,
    email: 'marc.john@raising-standards.com',
    phone: '+49 1579 250 14 50'  
  },
  'goran-djuric': {
    name: 'Goran Djuric',
    position: 'Principal Consultant',
    image: GoranDjuricImg,
    email: 'goran.djuric@raising-standards.com',
    phone: '+49 1579 250 14 51'
  },
  'tim-boehme': {
    name: 'Tim Böhme',
    position: 'Junior Consultant',
    image: TimBoehmeImg,
    email: 'tim.boehme@raising-standards.com',
    phone: '+49 1579 247 45 42'
  },
  'pier-paolo-muntoni': {
    name: 'Pier Paolo Muntoni',
    position: 'Senior Consultant',
    image: PierPaoloMuntoniImg,
    email: 'pier-paolo.muntoni@raising-standards.com',
    phone: '+49 1579 238 35 19'
  },
  'leif-haack': {
    name: 'Leif Haack',
    position: 'Consultant',
    image: LeifHaackImg,
    email: 'leif.haack@raising-standards.com',
    phone: '+49 157 928 117 51'
  },
  'stefan-rampe': {
    name: 'Stefan Rampe',
    position: 'Senior Consultant',
    image: StefanRampeImg,
    email: 'stefan.rampe@raising-standards.com',
    phone: '+49 157 928 117 52'
  },
  'adnan-aoudou': {
    name: 'Adnan Aoudou',
    position: 'Principal Consultant',
    image: AdnanAoudouImg,
    email: 'adnan.aoudou@raising-standards.com',
    phone: '+49 1579 238 36 40'
  },
  'kira-muehlberg': {
    name: 'Kira Mühlberg',
    position: 'Consultant',
    image: KiraMuehlbergImg,
    email: 'kira.muehlberg@raising-standards.com',
    phone: '+49 1579 281 17 55'
  },
  'linda-aragon': {
    name: 'Linda Aragon',
    position: 'Junior Consultant',
    image: LindaAragonImg,
    email: 'linda.aragon@raising-standards.com',
    phone: '+49 1579 247 45 40'
  },
  'adrian-tieber': {
    name: 'Adrian Tieber',
    position: 'Junior Consultant',
    image: AdrianTieberImg,
    email: 'adrian.tieber@raising-standards.com',
    phone: '+49 1579 281 17 56'
  }
};

/**
 * Get employee by URL slug, or null if not found.
 * @param {string} slug - From URL path (e.g. "tim-heymann")
 */
export function getEmployee(slug) {
  if (!slug || typeof slug !== 'string') return null;
  const normalized = slug.trim().toLowerCase();
  return employees[normalized] ?? null;
}

/**
 * Default employee slug when visiting / (root).
 * Clients should use /employee-slug in emails; root falls back to this.
 */
export const defaultEmployeeSlug = 'tim-heymann';
